import React, { useState, useEffect } from "react";
import "./darkModeSwitch.scss";

const DarkModeSwitch = ({ closeProfile = () => {} }) => {
  const [theme, setTheme] = useState(localStorage.getItem("theme") || "light");

  useEffect(() => {
    document.documentElement.setAttribute("data-theme", theme);
    localStorage.setItem("theme", theme);
  }, [theme]);

  const handleTheme = () => {
    setTheme(theme === "light" ? "dark" : "light");
    setTimeout(() => {
      closeProfile();
    });
  };

  return (
    <div className="switch-container">
      <label className="switch">
        <input
          type="checkbox"
          checked={theme === "dark"}
          onChange={handleTheme}
        />
        <span className="slider round"></span>
      </label>
    </div>
  );
};

export default DarkModeSwitch;
